module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column h-100 position-relative"
  }, [_c('div', {
    staticClass: "navigator",
    staticStyle: {
      "height": "65px"
    }
  }, [_c('h2', {
    staticClass: "mr-auto"
  }, [_vm._v("Reports")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 ml-auto"
  }, [_c('v-select', {
    attrs: {
      "options": _vm.timeOptions
    },
    on: {
      "input": _vm.rangeDropdownChanged
    },
    model: {
      value: (_vm.selectedTimeOption),
      callback: function($$v) {
        _vm.selectedTimeOption = $$v
      },
      expression: "selectedTimeOption"
    }
  })], 1), _vm._v(" "), (_vm.selectedTimeOption.value == 'custom') ? _c('div', {
    staticClass: "d-flex flex-row align-items-center"
  }, [_c('i', {
    staticClass: "ico ico-calendar fs-large dark mr-3"
  }), _vm._v(" "), _c('date-picker-new', {
    key: _vm.pickerKey,
    staticClass: "dateRangePicker",
    attrs: {
      "range": true,
      "clearOutside": true,
      "showFromTo": false
    },
    on: {
      "input": _vm.dateRangeChanged
    },
    model: {
      value: (_vm.customDate),
      callback: function($$v) {
        _vm.customDate = $$v
      },
      expression: "customDate"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.dashboardData == null) ? _c('div', {
    staticClass: "dark fs-larger font-weight-600 text-center mt-4"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "d-flex mt-1 px-5 mb-2 flexGrow1 overflow-auto align-items-start"
  }, [_c('div', {
    staticClass: "row w-100"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('cardGraphOccupancy', {
    staticClass: "mt-3",
    attrs: {
      "title": "Occupancy",
      "subTitle": _vm.cardLabel,
      "loading": !_vm.dashboardData,
      "percent": _vm.dashboardData.occupancy.totalOccupancyPercentage,
      "label": _vm.dashboardData.occupancy.totalOccupancy + ' of ' + _vm.dashboardData.occupancy.total,
      "labelColor": '#FF00FF'
    }
  })], 1), _vm._v(" "), (_vm.showTotalSales) ? _c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('cardSimple', {
    staticClass: "mt-3",
    attrs: {
      "title": "Total Sales",
      "subTitle": _vm.cardLabel,
      "value1": _vm.dashboardData.sales.totalSales + '€',
      "value2": _vm.dashboardData.sales.totalTickets + ' Bookings',
      "value2Class": 'color-3'
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('cardSimple', {
    staticClass: "mt-3",
    attrs: {
      "title": "Avg. Sale / Person",
      "subTitle": _vm.cardLabel,
      "value1": _vm.dashboardData.sales.averageSalePerPersonExtended
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-3"
  }, [_c('cardSimple', {
    staticClass: "mt-3",
    attrs: {
      "title": "Canceled",
      "subTitle": _vm.cardLabel,
      "value1": _vm.dashboardData.sales.totalCancellations
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-6"
  }, [_c('cardGraphSummary', {
    staticClass: "mt-3",
    attrs: {
      "title": 'Ticket Sales',
      "graphLabels": _vm.dashboardData.chart.labels,
      "graphValues": _vm.dashboardData.chart.data
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 col-lg-6"
  }, [_c('card-download', {
    staticClass: "mt-3",
    attrs: {
      "subTitle": _vm.cardLabel,
      "dateFrom": _vm.pickerDateFrom,
      "dateTo": _vm.pickerDateTo
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2481efae"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/Reports.vue
// module id = 2578
// module chunks = 0